import React from "react";
import { Modal, Box, Slide, Button, Typography, styled } from "@mui/material";
import { ReactComponent as Logo } from "../../../assets/icons/logo.svg";
import "./rightSideBarStyle.css";
import LogoutandDeleteModal from "./LogoutandDeleteModal/LogoutandDeleteModal";

const StyledButton = styled(Button)({
  width: "100%",
  fontFamily: "Poppins",
  fontWeight: 700,
  fontSize: ".5vw",
  lineHeight: ".65vw",
  height: "1.6vw",
  borderRadius: ".25vw",
  color: "#FFF",
  border: ".05vw solid #fff",
  textTransform: "none",
  backgroundColor: "transparent",
  "&:hover": {
    backgroundColor: "#fff",
    color: "#000",
  },
});

const RightSideBarModal = ({
  open,
  handleClose,
  logoutModal,
  setLogoutModal,
}) => {
  
  const handleNavigation = () => {
    window.open(`${process.env.REACT_APP_VISION_URL}`, "_blank");
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        BackdropProps={{ style: { backgroundColor: "transparent" } }}
      >
        <Slide
          direction="left"
          in={open}
          timeout={500}
          mountOnEnter
          unmountOnExit
        >
          <Box className="main">
            {/* header and section */}
            <Box className="main-box">
              <Typography className="main-title">Apps</Typography>
              {/* card */}
              <Box className="Card-Content" onClick={handleNavigation}>
                <Box className="Card-logo">
                  <Logo />
                </Box>
                <Typography className="Card-title">Vision Web</Typography>
              </Box>
              {/** */}
            </Box>
            {/* Footer */}
            <Box className="footer-modal">
              <StyledButton
                onClick={() => {
                  setLogoutModal(true);
                  handleClose();
                }}
              >
                Logout
              </StyledButton>
            </Box>
          </Box>
        </Slide>
      </Modal>

      {/*modal*/}
      <LogoutandDeleteModal
        openModal={logoutModal}
        handleClose={() => setLogoutModal()}
        modalType={"logout"}
      />
    </>
  );
};

export default RightSideBarModal;

